
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-8 col-md-7 col-xs-12">
          <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
          <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
      </div>
    </div>
    <div class="col-lg-8 col-md-12 col-xs-12">
      <div class="card">
        <table class="table">
          <thead>
            <tr>
                <th>Domain Name</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i = index">
              <td style="width:25%;">{{ row.domainName }}</td>
              <td style="width:25%;">{{ row.status }}</td>
              <td style="width:25%;">{{ printDate(row.createdAt) }}</td>
              <td style="width:25%;">
                  <span *ngIf="row.status=='pending'" title="Re-send Confirmation" class="glyphicon glyphicon-envelope" style="margin-left:5px;cursor:pointer;" aria-hidden="true" (click)="resendConfirmation(row)"></span>
                  <span *ngIf="row.status=='pending'"> | </span>
                  <span title="Remove IdP Domain" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  